/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { Entity } from '../model/models';
import { EntityMenu } from '../model/models';
import { EntitySearchResponse } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface EntitiesServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * This api will give you a entity of entities by its given name
     * This api will give you a entity of entities by its given name
     * @param name Search for one Entity in Entities
     */
    getEntityByName(name?: string, extraHttpRequestParams?: any): Observable<Entity>;

    /**
     * Fetches a list of EntityMenu items
     * This api will give you a list of EntityMenu items
     */
    getEntityMenuList(extraHttpRequestParams?: any): Observable<Array<EntityMenu>>;

    /**
     * this interface returns a subitem from a json for a given name and component
     * this interface returns a subitem from a json for a given name and component
     * @param name Search for one Entity in Entities
     * @param component specify which subitem in the json should be searched for
     * @param requestBody 
     */
    getEntitySearchRows(name?: string, component?: string, requestBody?: { [key: string]: any; }, extraHttpRequestParams?: any): Observable<EntitySearchResponse>;

    /**
     * this interface returns a subitem from a json for a given name and component
     * this interface returns a subitem from a json for a given name and component
     * @param name Search for one Entity in Entities
     * @param component specify which subitem in the json should be searched for
     */
    getEntitySubitemByNameAndComponent(name?: string, component?: string, extraHttpRequestParams?: any): Observable<string>;

}
